module.exports = __webpack_public_path__ + "img/pencil.968994c1.svg";